import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import {deleteArrayItemByKeyValue, objectFilter} from "../../utils/misc";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";


class EmployeeList extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            updatePermission: 0,
            createPermission: 0,
            employees: null,
            pages: null,
            filters: {
                archived: false,
            },
            filterFields: null,
        };
    }

    async componentDidMount() {
        await this.retrieveEmployees();
        await this.retrieveFilterFields();
        await this.retrievePermission();
    }

    async retrievePermission() {
        let updatePermission = await retrievePermission(
            'EmployeeViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        let createPermission = await retrievePermission(
            'EmployeeViewSet',
            'create',
            this.context.subscriberObject
        );
        await this.setState({
            updatePermission: updatePermission,
            createPermission: createPermission,
        });
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.params.pageNumber !== this.props.params.pageNumber) {
            await this.retrieveEmployees();
        }
    }

    async retrieveFilterFields() {
        const url = 'employee/update_form/';
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                fields: JSON.stringify([
                    'archived',
                ])
            }
        );
        let filterFields = response.data;
        filterFields = deleteArrayItemByKeyValue(
            filterFields,
            'name',
            'submitButton'
        );
        await this.setState({
            filterFields: filterFields,
        });
    }

    async filterCallBack(filters) {
        filters = objectFilter(
            filters,
            (e) => (e !== '' || !!e)
        );
        await this.setState({
            filters: filters
        });
        await this.retrieveEmployees();
    }

    async retrieveEmployees() {
        this.setState({
            employees: null,
            pages: null,
        });
        const url = 'employee/';
        const api = new BaseApi();
        let params = {
            ...this.state.filters,
        };
        if (this.props.params.pageNumber) {
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404) {
            params['page'] = 1;
        }
        response = await api.get(url, params);
        await this.setState({
            employees: response.data.results,
            pages: response.data.total_pages,
        });
    }

    render() {
        if (!this.state.employees) {
            return (<CircularProgress/>);
        }
        if (!this.state.pages) {
            return (<CircularProgress/>);
        }
        if (!this.state.filterFields) {
            return (<CircularProgress/>);
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Сотрудники'}
                    url={'employee'}
                    data={this.state.employees}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber !== undefined ? parseInt(this.props.params.pageNumber) : 1}
                    filterFields={this.state.filterFields}
                    filterCallBack={this.filterCallBack.bind(this)}
                    fields={[
                        {
                            title: 'ФИО',
                            name: 'full_name',
                            visible: true,
                            linkPattern: '/employee/detail/:linkParam',
                            linkParam: 'id',
                            linkTarget: '_self',
                        },
                        {
                            title: 'Категория',
                            name: 'category_human',
                            visible: true,
                            chip: true,
                            color_rule: () => ('primary'),
                        },
                        {
                            title: 'Зарплата',
                            name: 'real_salary',
                            visible: true,
                            preProcess: (v) => v ? `${Number(v).toFixed(2)} ₽` : '',
                        },
                        {
                            title: 'Архив',
                            name: 'archived',
                            visible: true,
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                    ]}
                />
            </Box>
        );
    }
}

export default withRouter(EmployeeList);
